export interface IManufacturer {
  manufacturerId: string;
  manufacturerName: string;
  isActive: boolean;
}
